export const quoteStepForTarget = ({ tab, anchor }) => {
  if (tab === 'PEOPLE') {
    return 1;
  }
  if (tab === 'SETTINGS') {
    return 4;
  }
  return /coverage|sppContainer|includeUmbrella|farmLiability|farmPolicyWide|interestedParties|lienHolders/i.test(
    anchor
  ) || tab === 'PIP'
    ? 3
    : 2;
};
